import React from 'react';

import {
  Dialog as DialogUI,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { Transition } from './components';

const useStyles = makeStyles((theme) => ({
  appBar: { position: 'fixed' },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: '#fff',
    textTransform: 'uppercase',
    fontSize: '2rem',
  },
  container: {
    backgroundColor: '#f4f6f8',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

function Dialog({ toggle, open, title, children, fullScreen }) {
  const classes = useStyles();

  return (
    <DialogUI
      fullScreen={fullScreen}
      onClose={toggle}
      open={open}
      TransitionComponent={Transition}
    >
      {!isEmpty(title) && (
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={toggle}
              aria-label="close"
            >
              <Close />
            </IconButton>
            <Typography variant="h4" className={classes.title}>
              {title}
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      <div
        className={classes.container}
        style={{ marginTop: isEmpty(title) ? 0 : 65 }}
      >
        {children}
      </div>
    </DialogUI>
  );
}

Dialog.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool,
};

Dialog.defaultProps = {
  title: '',
  fullScreen: true,
};

export default Dialog;
